import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import 'tails-ui/dist/index.css';
import DataTable from 'react-data-table-component';


class SubscritpionsListView extends  React.Component {
    constructor( props ) {
        super( props );
    }
  
   render(){
    let sn_count = 1;
    if(this.props.pagechange != 1){
        let pageindex = (this.props.pagechange - 1) * 20 ;
        this.props.userData.forEach((listdata, index) => { listdata.serial = pageindex + sn_count; sn_count++ })
    }
    else{
        this.props.userData.forEach((listdata, index) => { listdata.serial = sn_count; sn_count++});
    }
    
    const columns = [      
        {
            name: '#',
            selector: 'serial',
            // cell: (row) => {
               
            // },
           
            
        },
        {
            name: 'Subscription Title',
            selector: 'subscription_title',
            
        },
        {
            name: 'Report Name',
            selector: 'report_name',
           
        },
        {
            name: 'Detail',
            selector: 'detail',
          
        },
      
        // {
        //     name: 'FORMAT',
        //     selector: 'format',
            
        // },       
        {
            name: 'Action',
            selector: 'action',           
            cell: row => <div className="button-wrap">               
                <button onClick={this.props.handleEditList}
                        className="MuiButtonBase-root MuiIconButton-root MuiIconButton-colorInherit" tabIndex="0"
                        type="button" title="Edit" id={row.id}><span className="MuiIconButton-label"><span
                    className="material-icons MuiIcon-root" aria-hidden="true">edit</span></span><span
                    className="MuiTouchRipple-root"></span></button> 
              <button onClick={this.props.handleDeleteSubscription}
                        className="MuiButtonBase-root MuiIconButton-root MuiIconButton-colorInherit" tabIndex="0"
                        type="button" title="Delete" id={row.id}><span className="MuiIconButton-label"><span
                    className="material-icons MuiIcon-root" aria-hidden="true">delete_outline</span></span><span
                    className="MuiTouchRipple-root"></span></button>
            </div>,
        }
    ];
    return (
        <div>
        <div className="w-full mb-3 mx-auto flex flex-wrap items-center mt-0 p-6 report-datatable subscribe-table">                  
            <DataTable
                columns={columns}
                data={this.props.userData}
                progressPending={this.props.userLoading}
                pagination={true}
                paginationTotalRows={this.props.userRows}    
                paginationServer={true}                      
                paginationPerPage= {20}
                paginationComponentOptions={{
                    noRowsPerPage: true
                  }}
                onChangePage={this.props.handlePageChange}                    
            />
        </div>
    </div>
    );
   }
  
}

export default SubscritpionsListView
